import axios from "../../utils/axios";

async function login(data, shopId, config) {
  const res = await axios.post(`/shops/${shopId}/auth/login`, data, config);
  if (res.data) return res.data;
}
async function signup(data, shopId) {
  return await axios.post(`/shops/${shopId}/auth/signup`, data);
}
async function verifyEmail(data, shopId) {
  return await axios.post(`/shops/${shopId}/auth/verify-email`, data);
}

async function refreshToken() {
  const token = localStorage.getItem("refreshToken");
  const shopId = localStorage.getItem("shopId");
  let res = await axios.post(
    `/shops/${shopId}/auth/refresh`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return {
    accessToken: res.data.accessToken,
    refreshToken: res.data.refreshToken,
    user: res.data.user,
  };
}

async function resetPassword(payload, shopId) {
  return await axios.post(`/shops/${shopId}/auth/reset-password`, payload);
}

async function resetSuperAdminPassword(payload) {
  return await axios.post(`/auth/resetPassword`, payload);
}

async function changePassword(payload, shopId) {
  return await axios.post(`/shops/${shopId}/auth/change-password`, payload);
}
async function forgotPassword(email, shopId) {
  return await axios.post(`/shops/${shopId}/auth/${shopId}/forgot-password`, {
    email,
  });
}

async function setOtp(payload) {
  return await axios.post("/auth/sendOtp", payload);
}

async function logout() {
  return await axios.delete("/auth/logout");
}

async function shopLoginAs(shopId) {
  return axios.post(`/shops/${shopId}/auth/login-as`);
}

const authService = {
  login,
  logout,
  refreshToken,
  resetPassword,
  changePassword,
  setOtp,
  forgotPassword,
  signup,
  verifyEmail,
  shopLoginAs,
  resetSuperAdminPassword,
};

export default authService;
